import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-31" data-mp="gokq33tvjok1">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 px-3 py-3 backdrop-blur" data-id="element-32" data-mp="bqsofi3fgo2n">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-cta px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-lg transition-colors duration-150 ease-out hover:bg-cta-dark" data-id="element-33" data-mp="2b2740giwghwc">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-34" data-mp="26afl8s5zjggr" />
            Get instant access · $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}